var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbUpOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.28,
    height: 15.318,
    viewBox: "0 0 15.28 15.318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "like",
    d: "M14.613,7.533H11.722l.653-2.942a1.937,1.937,0,0,0-.728-1.967l-.45-.337a1.433,1.433,0,0,0-2.1.43,35.766,35.766,0,0,1-3.03,4.627.538.538,0,0,0-.484-.308H2.6a.538.538,0,0,0-.538.538v8.454a.538.538,0,0,0,.538.538H5.581A.532.532,0,0,0,6.1,16.1a2.983,2.983,0,0,0,2.184.962h2.954a2.963,2.963,0,0,0,2.47-1.322l2.936-4.4a2.447,2.447,0,0,0-2.036-3.8ZM5.043,15.49H3.135V8.112H5.043Zm10.711-4.75-2.936,4.4a1.89,1.89,0,0,1-1.575.843H8.288a1.9,1.9,0,0,1-1.515-.757l-.655-.873V8.832a26.008,26.008,0,0,0,3.907-5.578.35.35,0,0,1,.237-.171.359.359,0,0,1,.289.065L11,3.484a.861.861,0,0,1,.323.874l-.8,3.6a.538.538,0,0,0,.525.655h3.562a1.371,1.371,0,0,1,1.141,2.131Z",
    transform: "translate(-1.934 -1.87)",
    fill: "#383c3a",
    stroke: "#383c3a",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpOff);
export default __webpack_public_path__ + "static/media/thumb-up-off.8cd7cd9f30e2a0bd109d5e8e76a8c0f4.svg";
export { ForwardRef as ReactComponent };